import { useContext } from 'react';
import { AdvertListContextType } from '#advertList/contexts/AdvertListContextType';
import { AdvertListContext } from '#advertList/contexts/AdvertListContext';

const useAdvertListContext = () => useContext<AdvertListContextType>(AdvertListContext);

export { useAdvertListContext };
